// extracted by mini-css-extract-plugin
export default {"Hero":"zZAIJMHH6ecYDYFTGzuc","Hero_content":"B1JGyKu2vFQg7q9w_u4r","Hero_image":"kpYBIF75Oj29ZeZGOsoB"};